// import { MapContainer, TileLayer, useMap, Marker, Popup } from "react-leaflet";
import { MapContainer, TileLayer, Circle, Rectangle, useMap } from "react-leaflet";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import "../sass/Map.scss";
import dayjs from "dayjs";
import { isMobile } from "react-device-detect";
import React, { useContext, useEffect, useState } from "react";
import { SelectedDataSet } from "./context/SelectedDataset";
import { DomainContext } from "./context/DomainNameContext";
import { CityContext } from "./context/CityContext";
import GeoTiffDemo from "../GeoTiffDemo";
import { DateContext } from "./context/DateContext";
import { LayerContext } from "./context/LayerContext";
import { LoadingContext } from "./context/Loading";
import { PlayContext } from "./context/PlayContext";
import { toast } from "react-toastify";
import { BsFillPlayCircleFill } from "react-icons/bs";
import {BsFillPauseCircleFill} from "react-icons/bs";
import { LayerAddContext } from "./context/AddedLayer";
import ReactLoading from 'react-loading';
// https://leaflet-extras.github.io/leaflet-providers/preview/

const TimeDot = ({ date, status, onClick }) => {
  if (status === undefined) {
    status = "";
  }
  // console.log(date);
  return (
    <div className={"timeDot " + status} onClick={onClick}>
      <span className={`${!isMobile?"circle":"circle-mob"}`}></span>
      <span className={`${!isMobile?"label":"label-mob"}`}>{date}</span>

      {/* {status === "future" && (
        <Link to="/get-notified/chennai-temperature" className="btn">
          <FontAwesomeIcon icon={faBell} /> Get Notified
        </Link>
      )} */}
    </div>
  );
};

function Map({
  latitude,
  longitude,
  accuracy,
  boundingbox,
  timestamp,
  selectedIndex,
  setIndex,
  locData
}) {
  
  const {city}=useContext(CityContext)
  const { domainName } = useContext(DomainContext);
  const [isPlaying, setIsPlaying] = React.useState(false);
  const { selectedDataSet } = useContext(SelectedDataSet);
  const {getSelectedDataSet}= useContext(SelectedDataSet);
  const { getDate } = useContext(DateContext);
  const { getLayer } = useContext(LayerContext);
  const { getLoading } = useContext(LoadingContext);
  const { loadingOn } = useContext(LoadingContext);
  const { getPlay } = useContext(PlayContext);
  const { layerAdded } = useContext(LayerAddContext);
  const togglePlay = (_ev) => {
    if (isPlaying == false) {
      console.log("coming inside?");
      handleTickOut();
    }
    setIsPlaying((p) => !p);
    getPlay(!isPlaying);
  };
  useEffect(() => {
    getDate(dayjs(Number(timestamp[4]) * 1000).format("DD MMM YYYY"))
  },[])
  // console.log(isPlaying);
  const handleTickOut = () => {
    // console.log("changing timeline or not");
    setIndex((p) => (p + 1) % timestamp.length);
    getLoading(true);
  };
  useEffect(() => {
    if (isPlaying && loadingOn == false) {
      setTimeout(() => {
        handleTickOut();
      },5500)
    }
  }, [isPlaying, loadingOn,selectedIndex])
  useEffect(() => {
    if (domainName) {
      setIsPlaying(false);
      getSelectedDataSet();
      setIndex(4);
      getPlay(false);
    }
  },[domainName,city])
  const center = [latitude,longitude];
  const fillRedOptions = { fillColor: "red" };
  const blackOptions = { color: "black", fillColor: "none" };
  // console.log(selectedIndex);
  // console.log(selectedDataSet);
  const notify = () => toast.error('You can not use play button without choosing any dataset', {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme:"dark",
  });
  const notifyWarn = () => toast.warn('Wait...Image is loading', {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme:"dark",
  });
  // console.log(isPlaying);
  // console.log(layerAdded);
  return (
    <div className={isMobile ? "mapContainer mobile-map" : "mapContainer"}>
      <GeoTiffDemo center={center} locData={locData} />
         <div className="timeline">
        <div onClick={() => {
          if ( selectedDataSet==undefined) {
            notify();
          }
          else if (selectedDataSet) {
            togglePlay();
          }
          
        }}>
          <span className="play-btn" style={{ cursor: "pointer" }}>{isPlaying ? <BsFillPauseCircleFill/> : <BsFillPlayCircleFill/>}</span>
        </div>

        {timestamp
          .slice(
            // Math.max(0, selectedIndex - 2),
            // Math.max(0, selectedIndex - 2) + 6
            0,5
          )
          .map((data, id) => {
            const isSelected = id === selectedIndex;

            return (
              <TimeDot
                className="date-container"
                key={id}
                date={!isMobile ?dayjs(Number(data) * 1000).format("DD MMM YYYY"):dayjs(Number(data) * 1000).format("DD-MM-YY")}
                status={isSelected ? "active" : undefined}
                onClick={() => {
                  if (layerAdded == true || selectedDataSet==undefined) {
                    getLayer(false);
                    getDate(dayjs(Number(data) * 1000).format("DD MMM YYYY"));
                    setIndex(id);
                  }
                  else if (selectedDataSet && layerAdded == false) {
                    notifyWarn();
                  }
                }}
              />
            );
          })}
        {/* <TimeDot date="Future" status="future" /> */}
      </div>
      

      {/* <span className="mask mTop"></span>
      <span className={`${selectedIdx && selectedIdx.length>0 ?"mask mBottom":"mask mBottom"}`}></span>
      <span className="mask mLeft"></span>
      <span className="mask mRight"></span> */}
    </div>
  );
}

export default Map;
